import React from "react";

const MainLoading = () => {
  return (
    <div className="loaderavi">
    <div id="main-loading" className="main-loading">
      <div className="main-loading-powered-by">
        <div className="main-loading-powered-by-base64"></div>
      </div>

      <div className="main-loading-logo main-loading-logo-base64"></div>

      <div className="spinner">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    </div>
  );
};

export default MainLoading;
